import React from 'react';
import { FiXCircle } from 'react-icons/fi';


const ListFilters = ({ list, products }) => {

    /* a lista é formada por { title: '', value: '', changeValue : () => {}} */
    return <div className='row-start gap-sm full-width' style={{ maxWidth: '1600px' }}>
        {list?.map(i => {
            if (!i?.value) {
                return <></>;
            }

            if (i?.column === 'product_id') {

                const product = products?.find(item => item?._id?.toString() === i?.value?.toString());

                return <nav className='selectCardMini'><p>{i?.title}:<br /><strong>{product?.title}</strong> </p><FiXCircle onClick={() => i?.changeValue('')} /></nav>
            }
            if (i?.column === 'payment_method_id') {
                const status = {
                    credit_card: 'Cartão de crédito',
                    boleto: 'Boleto',
                    pix: 'PIX'
                }

                return <nav className='selectCardMini'><p>{i?.title}:<br /><strong>{status?.[i?.value] ? status?.[i?.value] : 'Gratuito'}</strong> </p><FiXCircle onClick={() => i?.changeValue('')} /></nav>
            }
            if (i?.column === 'payment_status_id') {
                const status = {
                    paid: 'Pago',
                    waiting: 'Aguardando pagamento',
                    cancelled: 'Cancelado'
                }

                return <nav className='selectCardMini'><p>{i?.title}:<br /><strong>{status?.[i?.value] ? status?.[i?.value] : i?.value}</strong> </p><FiXCircle onClick={() => i?.changeValue('')} /></nav>
            }

            return <nav className='selectCardMini'><p>{i?.title}:<br /><strong>{i?.value}</strong> </p><FiXCircle /></nav>
        })}
    </div>

}

export default ListFilters;